export default __webpack_public_path__ + "static/media/password-light-icon.63f70d3b.svg";